import './TaskSummary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { InitiativeSubSection } from '../general/InitiativeSubSection';
import { Progress } from 'antd';
import React from 'react';
import { SonarText } from '@ui/text';
import { useInitiativeTasks } from '@hooks';
import { CheckCircleOutlined, UnorderedListOutlined } from '@ant-design/icons';

export interface InitiativeTasksSummaryProps {
	initiativeId: number;
}

export const InitiativeTasksSummary: React.FC<InitiativeTasksSummaryProps> = ({ initiativeId }) => {
	const { tasks } = useInitiativeTasks(initiativeId);
	const taskCount = tasks.length;
	const completedTaskCount = tasks.filter((task) => task.completed).length ?? 0;
	const taskProgress = Math.floor((completedTaskCount / taskCount) * 100);

	if (!taskCount) {
		return null;
	}

	const tasksCompletedText = `${completedTaskCount}/${taskCount} ${COPY_SPECIFIC.COMPLETE}`;

	return (
		<>
			<Progress
				className='initiative-task-progress-bar'
				percent={ taskProgress } />
			<InitiativeSubSection
				count={ taskCount }
				direction='horizontal'
				icon={ <UnorderedListOutlined /> }
				id='initiative-task-summary'
				reducedPadding
				title={ COPY_SPECIFIC.TASKS }>
				<span>
					<CheckCircleOutlined />
					<SonarText>{ tasksCompletedText }</SonarText>
				</span>
			</InitiativeSubSection>
		</>
	);
};
